<template>
    <main
        v-if="item"
        class="page">
        <div class="content">
            <CmsHeaderImage
                :image="item.header_image"
                :renditions="item.header_image_renditions" />
            <template v-for="block in item.content">
                <component
                    :is="getBlockComponent(block)"
                    :block="block" />
            </template>
        </div>
    </main>
    <main
        v-else
        class="page">
        <div class="content">
            <h1 class="color-secondary">
                {{ $t("Oh no. This page does not exist.") }}
            </h1>
        </div>
    </main>
</template>

<script>
    import CmsPageMixin from "@/components/cms/CmsPageMixin.js";

    export default {
        name: "CmsPage",
        mixins: [CmsPageMixin],
        data() {
            return {
                type: "contentpage",
                fields: [
                    "content",
                    "title",
                    "header_image",
                    "header_image_renditions",
                    "seo_title",
                    "search_description"
                ]
            };
        },
        computed: {
            extraParams() {
                return {
                    slug: this.$route.params.slug
                };
            }
        }
    };
</script>

<style scoped lang="scss">
    @import "~@/styles/variables";

    .page {
        h1 {
            font-size: 2rem;
            margin-top: 3.75rem;
        }
    }
</style>
